import RxProductPriceDetail from "./RxProductPriceDetail";

export default RxProductPriceDetail;
